import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { TRACK_LOADING } from 'src/app/core/tokens/http-loading.token'; // 👈 importa el token

const base_url = environment.base;

@Injectable({ providedIn: 'root' })
export class FirmaService {

  private endpoint = 'usuarios';

  constructor(private http: HttpClient) {}

  get headers() {
    return {
      headers: {
        // tus headers si los necesitas
      }
    };
  }

  createLotes(jsonPayload: any) {
    const url = `${base_url}lotes`;
    return this.http.post<any>(
      url,
      jsonPayload,
      {
        ...this.headers,
        context: new HttpContext().set(TRACK_LOADING, true), // 👈 loader global
      }
    );
  }

  firmaLogin(scratchcard: string, loteId: string) {
    const url = `${base_url}/lotes/${loteId}/firmas/electronicas/masivas/login`;

    return this.http.post<any>(
      url,
      { scratchcard },
      {
        ...this.headers,
        observe: 'response' as const,
        context: new HttpContext().set(TRACK_LOADING, true), // 👈 loader global
      }
    );
  }

  firmaMasiva(scratchcard: string, loteId: string) {
    const url = `${base_url}/lotes/${loteId}/firmas/electronicas/masivas`;

    return this.http.post<any>(
      url,
      { scratchcard },
      {
        ...this.headers,
        observe: 'response' as const,
        context: new HttpContext().set(TRACK_LOADING, true), // 👈 loader global
      }
    );
  }
}
